<template>
    <transition name="destAirlineSearch">
        <div v-if="sel" class="destAirlineSearch">
            <div ref="destAirlineQuery"
                 class="destAirlineQuery"
                 @click.stop>
                <div class="close" @click="close">
                    <i class="iconfont icon-chahao"></i>
                </div>
                <div class="titsBox">
                    <a v-for="(item,index) in cmpt"
                       :key="index"
                       :class="{item:true,active:isActiveTitsBoxA === item}"
                       href="javascript:void(0);"
                       @click="titsBoxClick(item)">{{cmptNameC[item]}}</a>
                </div>
                <hr class="hr">
                <div class="classifyBox">
                    <a v-for="(item,index) in classifyData"
                       :key="index"
                       :class="{active:isActiveClassifyBoxA === item}"
                       href="javascript:void(0);"
                       @click="classifyBoxClick(item)">{{item}}</a>
                </div>
                <div class="dataList">
                    <a v-for="(item,index) in dataListData"
                       :key="index"
                       :title="item.value"
                       href="javascript:void(0);"
                       @click="dataListClick(item.fuzzy)">{{item.value}}</a>
                </div>
            </div>
            <div ref="destAirlineFuzzy"
                 class="destAirlineFuzzy"
                 @click.stop>
                <a v-for="(item,index) in fuzzyData"
                   :key="index"
                   href="javascript:void(0);"
                   :class="{fuzzy:true,invalid:item.invalid}"
                   @click="fuzzyClick(item)">
                    <span class="text1"
                          :title="item.textTitle1"
                          v-html="item.text1"></span>
                    <span class="text2"
                          :title="item.textTitle2"
                          v-html="item.text2"></span>
                    <span class="text3"
                          :title="item.textTitle3"
                          v-html="item.text3"></span>
                    <span class="now" :title="item.now">{{item.now}}</span>
                </a>
            </div>
            <div ref="destAirlineLoading"
                 class="destAirlineLoading"
                 @click.stop>
                <SJMLoading type="chrome" top="50%"></SJMLoading>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'DestAirlineSearch',
        data() {
            return {
                // 功能数组对应中文名
                cmptNameC: {
                    dest: this.$t('message.endPort'),
                    startPort: this.$t('message.startPort'),
                    airline: this.$t('message.airline')
                },
                data: null,// 总数据
                classifyData: [],// 航司目的港下面的分类数组
                dataListData: [],// 点击查询页具体数据
                fuzzyData: [],// 模糊查询数据
                dataAjax: null,// 数据Ajax
                isActiveTitsBoxA: null,// 选中航司目的港
                isActiveClassifyBoxA: null,// 选中航司目的港下面的分类
                isShowDestAirlineQuery: false,
                isShowDestAirlineFuzzy: false,
                isShowDestAirlineLoading: false,
                cityName: this.$i18n.locale === 'en' ? 'cityNameE' : 'cityNameC',// 城市名
                countryName: this.$i18n.locale === 'en' ? 'countryNameE' : 'countryNameC',// 国家名
                airlineName: this.$i18n.locale === 'en' ? 'airlineNameE' : 'airlineNameC',// 航司名
                areaName: this.$i18n.locale === 'en' ? 'areaNameE' : 'areaNameC',// 区域名
            };
        },
        // 计算属性
        computed: {
            sel() {
                return this.$store.state.DestAirlineSearch.sel;
            },
            // 开启功能
            cmpt() {
                return this.$store.state.DestAirlineSearch.cmpt;
            },
            // 产品编号
            productNo() {
                return String(this.$store.state.DestAirlineSearch.productNo).trim();
            },
            // 偏移量Top
            top() {
                return this.$store.state.DestAirlineSearch.top;
            },
            // 偏移量Left
            left() {
                return this.$store.state.DestAirlineSearch.left;
            },
            // 偏移量Right
            right() {
                return this.$store.state.DestAirlineSearch.right;
            },
            // 语言
            lang() {
                return this.$store.state.DestAirlineSearch.lang;
            },
            // 动态跟随开关
            follow() {
                return this.$store.state.DestAirlineSearch.follow;
            },
            // 点击结果回调事件
            callback() {
                return this.$store.state.DestAirlineSearch.callback;
            },
            // 输入框回车回调事件
            enterCallback() {
                return this.$store.state.DestAirlineSearch.enterCallback;
            },
            // 插件层级
            zIndex() {
                return this.$store.state.DestAirlineSearch.zIndex;
            },
            // input清空错误数据 默认开启
            cleanInput() {
                return this.$store.state.DestAirlineSearch.cleanInput;
            },
            // 插件输入框数据
            inputData() {
                return this.$store.state.DestAirlineSearch.inputData;
            },
            // input对应model对象
            inputModel() {
                return this.$store.state.DestAirlineSearch.inputModel;
            },
            // 隐藏插件
            hideFn() {
                return this.$store.state.DestAirlineSearch.hideFn;
            },
            // 只有传入的产品
            onlyProduct() {
                return this.$store.state.DestAirlineSearch.onlyProduct;
            },
            // 始发港Ajax
            startPortAjaxComplete() {
                return this.$store.state.StartPort.startPortAjaxComplete;
            },
            // 始发港数据
            startPort() {
                return this.$store.state.StartPort.startPort;
            },
        },
        watch: {
            // ref改变
            sel(newValue, oldValue) {
                this.fuzzyData = [];// 模糊查询数据清空
                if (newValue) {// 必须有sel才执行
                    this.$nextTick(() => {
                        this.init(oldValue);// 初始Fn
                    });
                }
            },
            // 产品编号变更
            productNo() {
                this.$nextTick(() => {
                    this.dataAjaxFn();// 获取数据ajax
                });
            },
            // 类型 0或空-全部目的港、1-该产品的目的港
            onlyProduct() {
                this.$nextTick(() => {
                    this.dataAjaxFn();// 获取数据ajax
                });
            },
            // 是否强制动态跟随
            follow() {
                if (this.follow) {
                    this.$(window).on('resize scroll', this.dynamicFollowFn);// 动态跟随
                }
            },
            // 隐藏插件
            hideFn() {
                this.hidePluginFn();// 隐藏插件Fn
            }
        },
        mounted() {
            // 切换路由关闭插件
            this.$router.beforeEach((to, from, next) => {
                this.close();// 关闭插件
                next();
            });
        },
        methods: {
            // 关闭插件
            close() {
                this.$(document).off('click', this.clickDocument);
                this.$(window).off('resize scroll', this.dynamicFollowFn);
                this.$store.commit('DestAirlineSearch/ReloadPlugin', {});
            },
            // 点击屏幕外部
            clickDocument() {
                if (!this.sel) {
                    return;
                }
                if (!this.$(this.sel).is(':focus')) {
                    if (this.cleanInput) {
                        this.cleanInputErrFn();// 清空input错误的数据Fn
                    }
                    this.$nextTick(() => {
                        this.close();// 关闭插件
                    });
                }
            },
            // 初始Fn
            init(oldRef) {
                // 点击屏幕关闭检索框
                this.$(document).on('click', this.clickDocument);
                if (oldRef) {
                    this.$(oldRef).off('input keyup focus click');
                } else {
                    this.$(this.sel).off('input keyup focus click');
                }
                this.initDomRenderer();// 初始化dom样式操作
                this.dynamicFollowFn();// 动态跟随Fn;
                this.eventInputFn();// input事件Fn
            },
            // 初始化dom样式操作
            initDomRenderer() {
                // zIndex
                this.$refs.destAirlineQuery.style.zIndex = this.zIndex;
                this.$refs.destAirlineFuzzy.style.zIndex = this.zIndex;
                this.$refs.destAirlineLoading.style.zIndex = this.zIndex;
            },
            // 动态跟随Fn
            dynamicFollowFn() {
                this.$nextTick(() => {
                    if (!this.sel) {
                        return;
                    }
                    // 绑定位置
                    let documentWidth = document.body.clientWidth;// 屏幕宽度
                    let top = this.$(this.sel).offset().top + this.$(this.sel).outerHeight(true) + Number(this.top);
                    let leftPos = this.$(this.sel).offset().left;// 左侧定位数值
                    let RightPos = documentWidth - (leftPos + this.$(this.sel).outerWidth(true));// 右侧定位数值
                    if (this.left !== null) {
                        leftPos = leftPos + Number(this.left) + 'px';
                        RightPos = 'auto';
                    } else if (this.right !== null) {
                        leftPos = 'auto';
                        RightPos = RightPos + Number(this.right) + 'px';
                    }
                    let css = {};// css对象
                    css['top'] = top + 'px';
                    css['left'] = leftPos;
                    css['right'] = RightPos;
                    this.$(this.$refs.destAirlineQuery).css(css);
                    this.$(this.$refs.destAirlineFuzzy).css(css);
                    this.$(this.$refs.destAirlineLoading).css(css);
                });
            },
            // 获取数据ajax
            dataAjaxFn() {
                this.data = null;
                this.$ajax({
                    name: 'dataAjax',
                    url: '/SmartProductsHandler/Common/CommonHandler.ashx',
                    data: {
                        act: 'getAirlineAndDestinationSearchData',// 获取 航司和目的港检索 数据
                        productNo: this.productNo,// 产品编号 如果为空字符串 就是全部产品
                        type: this.onlyProduct// 类型 0或空-全部目的港、1-该产品的目的港
                    },
                    beforeSend: () => {
                        this.$(this.$refs.destAirlineQuery).hide();
                        this.$(this.$refs.destAirlineFuzzy).hide();
                        if (this.$(this.sel).is(':focus')) {
                            this.$(this.$refs.destAirlineLoading).show();
                        }
                    },
                    success: async (res) => {
                        this.data = res['success'];
                        // 获取始发港数据
                        if (this.onlyProduct !== '1') {
                            if (!this.startPortAjaxComplete) {
                                this.data.startPort = await this.getStartPortData();
                                // 始发港数据存入VueX
                                this.$store.commit('StartPort/startPort', this.data.startPort);
                                this.$store.commit('StartPort/startPortAjaxComplete', true);
                            } else {
                                this.data.startPort = this.startPort;
                            }
                        }
                        this.$(this.$refs.destAirlineLoading).hide();
                        if (this.$(this.sel).is(':focus')) {
                            this.$(this.$refs.destAirlineLoading).hide();
                            // 加载完了
                            if (this.$(this.sel).val().trim() === '') {
                                this.$(this.$refs.destAirlineQuery).show();
                                // this.$(this.$refs.destAirlineQuery).find('.titsBox > a:visible').eq(0).trigger('click');// 必须先显示再点击
                                this.titsBoxClick(this.cmpt[0]);
                                this.$(this.$refs.destAirlineFuzzy).hide();
                            } else {
                                this.$(this.$refs.destAirlineQuery).hide();
                                this.$(this.$refs.destAirlineFuzzy).show();
                                this.fuzzyRenderer();// 模糊查询渲染Fn
                            }
                        }
                    }
                });
            },
            // 获取始发港数据
            getStartPortData() {
                return new Promise((resolve, reject) => {
                    this.$ajax({
                        url: '/SmartProductsHandler/Common/CommonHandler.ashx',
                        data: {
                            act: 'getStartPortData',// 获取 起始港 数据
                        },
                        success: (res) => {
                            resolve(res.success.startPort);
                        },
                        error: () => {
                            reject([]);
                        }
                    });
                });
            },
            // 模糊查询渲染Fn
            fuzzyRenderer() {
                this.fuzzyData = [];// 模糊查询数据清空

                // 无数据直接停止
                if (this.data === null) {
                    return;
                }
                let regZH = new RegExp('[\\u4E00-\\u9FFF]+','g');
                let fuzzyData = this.$(this.sel).val().trim().toUpperCase();// 输入框输入的内容（转大写）
                let regExpList = ['\\', '(', ')', '[', ']', '*', '+', '?', '|'];// 正则关键字数组
                let fuzzyDataNew = fuzzyData;// 输入框输入的内容（转大写）New
                for (let i = 0; i < regExpList.length; i++) {
                    fuzzyDataNew = fuzzyDataNew.replace(new RegExp('\\' + regExpList[i], 'g'), '\\' + regExpList[i]);
                }

                let airlineListAll = this.data.airlineListAll;// 航司数据
                let destinationListAll = this.data.destinationListAll;// 目的港数据
                let startPort = this.data.startPort;// 始发港数据

                if (this.cmpt.includes('airline')) {
                   
                    // 航司检索
                    for (let i = 0; i < airlineListAll.length; i++) {
                        let airlineData = airlineListAll[i];// 得到每一个数据
                        if (regZH.test(fuzzyData)) {
                            if (
                                new RegExp(fuzzyDataNew, 'ig').test(airlineData['airlineNameC'])
                                ||                             
                                new RegExp(fuzzyDataNew, 'ig').test(airlineData['areaNameC'])                        
                            ) {
                                let text1 = airlineData['airlineAbbr'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let text2 = airlineData[this.airlineName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let text3 = airlineData[this.areaName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let textTitle1 = airlineData['airlineAbbr'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let textTitle2 = airlineData[this.airlineName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let textTitle3 = airlineData[this.areaName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let invalid = false;// 无效Class默认不开启
                                let fuzzy = airlineData['airlineAbbr'] + ',' + airlineData['areaNameE'];
                                let now = '';
                                this.fuzzyData.push({
                                    text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                });
                            }
                        } else {
                            if (fuzzyData.length <= 3) {
                                if (
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['airlineAbbr'])
                                    ||                             
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['areaNameC'])                        
                                ) {
                                    let text1 = airlineData['airlineAbbr'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text2 = airlineData[this.airlineName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text3 = airlineData[this.areaName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let textTitle1 = airlineData['airlineAbbr'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle2 = airlineData[this.airlineName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle3 = airlineData[this.areaName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let invalid = false;// 无效Class默认不开启
                                    let fuzzy = airlineData['airlineAbbr'] + ',' + airlineData['areaNameE'];
                                    let now = '';
                                    this.fuzzyData.push({
                                        text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                    });
                                }
                            } else {
                                if (
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['airlineAbbr'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['airlineNameC'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['airlineNameE'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['areaNameC'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(airlineData['areaNameE'])
                                ) {
                                    let text1 = airlineData['airlineAbbr'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text2 = airlineData[this.airlineName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text3 = airlineData[this.areaName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let textTitle1 = airlineData['airlineAbbr'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle2 = airlineData[this.airlineName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle3 = airlineData[this.areaName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let invalid = false;// 无效Class默认不开启
                                    let fuzzy = airlineData['airlineAbbr'] + ',' + airlineData['areaNameE'];
                                    let now = '';
                                    this.fuzzyData.push({
                                        text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                    });
                                }
                            }
                        }
                        
                        
                    }
                }

                if (this.cmpt.includes('startPort')) {
                   
                    // 始发港检索
                    for (let i = 0; i < startPort.length; i++) {
                        let startPortData = startPort[i];// 得到每一个数据
                        if (regZH.test(fuzzyData)) {
                            if (
                                new RegExp(fuzzyDataNew, 'ig').test(startPortData['nameC'])
                            ) {
                                let text1 = startPortData['port'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let text2 = startPortData['nameC'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let text3 = this.$t('message.china').replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let textTitle1 = startPortData['port'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let textTitle2 = startPortData['nameC'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let textTitle3 = this.$t('message.china');
                                let invalid = false;// 无效Class默认不开启
                                let fuzzy = startPortData['port'];
                                let now = '';
                                this.fuzzyData.push({
                                    text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                });
                            }
                        } else {
                            if (fuzzyData.length <= 3) {
                                if (
                                    new RegExp(fuzzyDataNew, 'ig').test(startPortData['port'])
                                ) {
                                    let text1 = startPortData['port'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text2 = startPortData['nameC'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text3 = this.$t('message.china').replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let textTitle1 = startPortData['port'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle2 = startPortData['nameC'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle3 = this.$t('message.china');
                                    let invalid = false;// 无效Class默认不开启
                                    let fuzzy = startPortData['port'];
                                    let now = '';
                                    this.fuzzyData.push({
                                        text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                    });
                                }
                            } else {
                                if (
                                    new RegExp(fuzzyDataNew, 'ig').test(startPortData['port'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(startPortData['nameC'])
                                ) {
                                    let text1 = startPortData['port'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text2 = startPortData['nameC'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text3 = this.$t('message.china').replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let textTitle1 = startPortData['port'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle2 = startPortData['nameC'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle3 = this.$t('message.china');
                                    let invalid = false;// 无效Class默认不开启
                                    let fuzzy = startPortData['port'];
                                    let now = '';
                                    this.fuzzyData.push({
                                        text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                    });
                                }
                            }
                        }
                        
                        
                    }
                }

                if (this.cmpt.includes('dest')) {
                    
                    // 目的港检索
                    for (let i = 0; i < destinationListAll.length; i++) {
                        let destinationData = destinationListAll[i];// 得到每一个数据
                        if (regZH.test(fuzzyData)) {
                            if (
                                new RegExp(fuzzyDataNew, 'ig').test(destinationData['cityNameC'])
                                ||  
                                new RegExp(fuzzyDataNew, 'ig').test(destinationData['countryNameC'])                          
                            ) {
                                let text1 = destinationData['airport'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let text2 = destinationData[this.cityName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let text3 = destinationData[this.countryName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                let textTitle1 = destinationData['airport'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let textTitle2 = destinationData[this.cityName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let textTitle3 = destinationData[this.countryName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                let now = '';// 当前产品
                                if (destinationData['range'] === '1') {
                                    now = this.$t('message.currentProduct');
                                }
                                let invalid = false;// 无效Class默认不开启
                                if (destinationData['valid'] === '0') {
                                    // 如果有效标志为0
                                    invalid = true;// 无效开启
                                }
                                let fuzzy = destinationData['airport'];
                                this.fuzzyData.push({
                                    text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                });
                            }
                        } else {
                            if (fuzzyData.length <= 3) {
                                if (
                                    new RegExp(fuzzyDataNew, 'ig').test(destinationData['airport'])                            
                                ) {
                                    let text1 = destinationData['airport'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text2 = destinationData[this.cityName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text3 = destinationData[this.countryName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let textTitle1 = destinationData['airport'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle2 = destinationData[this.cityName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle3 = destinationData[this.countryName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let now = '';// 当前产品
                                    if (destinationData['range'] === '1') {
                                        now = this.$t('message.currentProduct');
                                    }
                                    let invalid = false;// 无效Class默认不开启
                                    if (destinationData['valid'] === '0') {
                                        // 如果有效标志为0
                                        invalid = true;// 无效开启
                                    }
                                    let fuzzy = destinationData['airport'];
                                    this.fuzzyData.push({
                                        text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                    });
                                }
                            } else {
                                if (
                                    new RegExp(fuzzyDataNew, 'ig').test(destinationData['airport'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(destinationData['cityNameC'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(destinationData['cityNameE'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(destinationData['countryNameC'])
                                    ||
                                    new RegExp(fuzzyDataNew, 'ig').test(destinationData['countryNameE'])
                                ) {
                                    let text1 = destinationData['airport'].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text2 = destinationData[this.cityName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let text3 = destinationData[this.countryName].replace(new RegExp(fuzzyDataNew, 'ig'), '<em style="color: #409EFF;font-style: normal;">' + fuzzyData + '</em>');
                                    let textTitle1 = destinationData['airport'].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle2 = destinationData[this.cityName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let textTitle3 = destinationData[this.countryName].replace(new RegExp(fuzzyDataNew, 'ig'), fuzzyData);
                                    let now = '';// 当前产品
                                    if (destinationData['range'] === '1') {
                                        now = this.$t('message.currentProduct');
                                    }
                                    let invalid = false;// 无效Class默认不开启
                                    if (destinationData['valid'] === '0') {
                                        // 如果有效标志为0
                                        invalid = true;// 无效开启
                                    }
                                    let fuzzy = destinationData['airport'];
                                    this.fuzzyData.push({
                                        text1, text2, text3, textTitle1, textTitle2, textTitle3, invalid, fuzzy, now
                                    });
                                }
                            }
                        }
                        
                        
                    }
                }
                
                // 当前产品放第一
                if (this.productNo) {
                    this.fuzzyData.sort((a, b) => {
                        return b.now.length - a.now.length;
                    });
                }

                if (this.fuzzyData.length === 0) {
                    this.$(this.$refs.destAirlineFuzzy).hide();
                } else {
                    this.$(this.$refs.destAirlineFuzzy).show();
                }
                if (fuzzyData.length === 3 && (/^[a-zA-Z]+$/).test(fuzzyData)) {
                    let fuzzyDataClone = JSON.parse(JSON.stringify(this.fuzzyData));
                    let actIndex = -1;
                    for (let i in fuzzyDataClone) {
                        if (fuzzyDataClone[i].text1 && fuzzyDataClone[i].textTitle1 && fuzzyDataClone[i].text1 !== fuzzyDataClone[i].textTitle1) {
                            actIndex = i;
                            break; 
                        }                    
                    }
                    if (actIndex !== -1) {
                        fuzzyDataClone = [...fuzzyDataClone.splice(actIndex,1),...fuzzyDataClone];
                    }
                    this.fuzzyData = fuzzyDataClone;
                }
            },
            // input事件Fn
            eventInputFn() {
                // 输入框监听到事件
                this.$(this.sel).on('click focus input', () => {
                    this.$(this.$refs.destAirlineFuzzy).hide();
                    this.$(this.$refs.destAirlineQuery).hide();
                    this.$(this.$refs.destAirlineLoading).hide();
                    this.changeInputDataFn();// input改变数据fn
                });

                // 输入框input事件
                this.$(this.sel).on('input', (e) => {
                    this.$store.commit('DestAirlineSearch/inputData', e.target.value.trim());
                });

                // 输入框回车事件
                this.$(this.sel).on('keyup', (e) => {
                    if (e.keyCode !== 13) {
                        return;
                    }

                    this.$(this.$refs.destAirlineFuzzy).hide();

                    // 查询是否有模糊数据
                    if (this.fuzzyData.length !== 0) {
                        // 有数据
                        this.$store.commit('DestAirlineSearch/inputData', this.fuzzyData[0].fuzzy);
                        this.sel.value = this.fuzzyData[0].fuzzy;
                    } else {
                        this.$store.commit('DestAirlineSearch/inputData', this.$(this.sel).val());
                    }
                    if (this.enterCallback) {
                        this.$nextTick(() => {
                            this.enterCallback(e);// 执行回调
                        });
                    }
                });
            },
            // input改变数据fn
            changeInputDataFn() {
                this.$nextTick(() => {
                    if (!this.sel) {
                        return;
                    }
                    // 判定数据是否加载完毕
                    if (this.data === null) {// 没加载完
                        this.$(this.$refs.destAirlineFuzzy).hide();
                        this.$(this.$refs.destAirlineQuery).hide();
                        this.$(this.$refs.destAirlineLoading).show();
                    } else {// 加载完了
                        this.$(this.$refs.destAirlineLoading).hide();
                        if (this.$(this.sel).val().trim() === '') {// 没输入数据
                            this.$(this.$refs.destAirlineQuery).show();
                            if (this.$(this.sel).is(':focus')) {
                                // 一切为了IE
                                // this.$(this.$refs.destAirlineQuery).find('.titsBox > a').eq(0).trigger('click');// 必须先显示再点击（现在可以直接点击了）
                                this.titsBoxClick(this.cmpt[0]);
                            }
                            this.$(this.$refs.destAirlineFuzzy).hide();
                            this.fuzzyData = [];
                        } else {// 输入了数据
                            this.$(this.$refs.destAirlineQuery).hide();
                            this.$(this.$refs.destAirlineFuzzy).show();
                            this.fuzzyRenderer();// 模糊查询渲染Fn
                        }
                    }
                });
            },
            // 点击检索页数据
            fuzzyClick(item) {
                if (item.invalid) {
                    return;
                }
                if (!this.sel) {
                    return;
                }
                this.$store.commit('DestAirlineSearch/inputData', item.fuzzy);
                this.sel.value = item.fuzzy;
                this.$(this.$refs.destAirlineFuzzy).hide();
                if (this.callback) {
                    this.$nextTick(() => {
                        this.callback();// 执行回调
                    });
                }
            },
            // 点击插件切换航司目的港
            titsBoxClick(item) {
                this.isActiveTitsBoxA = item;// 选中样式
                this.classifyData = [];// 清空原有数据
                if (item === 'dest') {
                    // 当前为目的港
                    this.data.destinationList.map((item) => {
                        if (this.onlyProduct === '1') {
                            if (item.dataList && item.dataList.length > 0) {
                                this.classifyData.push(item.group);
                            }
                        } else {
                            this.classifyData.push(item.group);
                        }
                    });
                    if (this.classifyData.length > 0) {
                        this.classifyBoxClick(this.classifyData[0]);
                    }
                } else if (item === 'startPort') {
                    // 当前为始发港
                    this.classifyBoxClick();
                } else {
                    // 当前为航司
                    this.data.airlineList.map((item) => {
                        this.classifyData.push(item.group);
                    });
                    this.classifyBoxClick(this.classifyData[0]);
                }
            },
            // 点击切换分类
            classifyBoxClick(item = '') {
                this.isActiveClassifyBoxA = item;// 选中样式
                this.dataListData = [];// 清空原有数据
                if (this.isActiveTitsBoxA === 'dest') {
                    for (let i = 0; i < this.data.destinationList.length; i++) {
                        let list = this.data.destinationList[i];
                        if (list.group === item) {
                            list.dataList.map(items => {
                                this.dataListData.push({
                                    value: items[this.cityName].split(',')[0].split('，')[0].split('(')[0].split('（')[0],
                                    fuzzy: items[this.cityName]
                                });
                            });
                            break;
                        }
                    }
                } else if (this.isActiveTitsBoxA === 'startPort') {
                    this.data.startPort.map((item) => {
                        this.dataListData.push({
                            value: `${item.port} ${item.nameC}`,
                            fuzzy: item.port
                        });
                    });
                } else if (this.isActiveTitsBoxA === 'airline') {
                    for (let i = 0; i < this.data.airlineList.length; i++) {
                        let list = this.data.airlineList[i];
                        if (list.group === item) {
                            list.dataList.map(items => {
                                this.dataListData.push({
                                    value: `${items.airlineAbbr} ${items[this.airlineName]}`,
                                    fuzzy: items.airlineAbbr
                                });
                            });
                            break;
                        }
                    }
                }
            },
            // 点击查询页具体数据
            dataListClick(item) {
                this.$store.commit('DestAirlineSearch/inputData', item);
                this.sel.value = item;
                // this.$(this.$refs.destAirlineFuzzy).hide();
                // this.$(this.$refs.destAirlineQuery).hide();
                // this.$(this.$refs.destAirlineLoading).hide();
                // this.changeInputDataFn();// input改变数据fn
                this.$(this.sel).attr('data-trigger', '1');// 追加模拟点击属性
                this.$(this.sel).trigger('focus');// 模拟触发focus（可能有bug就用：this.changeInputDataFn）
            },
            // 清空input错误的数据Fn
            cleanInputErrFn() {
                let regExpArr = [];// 正则数组
                let isPass = false;// 是否正确 默认数据不符合规范
                this.cmpt.map(function (item) {
                    switch (item) {
                        case 'dest':
                            regExpArr.push(/^[a-zA-Z]{3}$/);
                            break;
                        case 'airline':
                            regExpArr.push(/^[a-zA-Z0-9]{2,3},[a-zA-Z]+$/);
                            break;
                    }
                });
                for (let i = 0; i < regExpArr.length; i++) {
                    if (regExpArr[i].test(this.$(this.sel).val().trim())) {
                        isPass = true;// 数据符合规范
                        break;
                    }
                }
                // 如果是错误数据就清空
                if (!isPass) {
                    this.$store.commit('DestAirlineSearch/inputData', '');
                    this.$(this.sel).val('');
                }
            },
            // 隐藏插件Fn
            hidePluginFn() {
                // $(this.sel).blur();
                this.$(this.$refs.destAirlineQuery).hide();
                this.$(this.$refs.destAirlineFuzzy).hide();
                this.$(this.$refs.destAirlineLoading).hide();
            }
        }
    };
</script>

<style scoped>
    .destAirlineSearch-enter-active,
    .destAirlineSearch-leave-active {
        transition: opacity 0.15s;
    }

    .destAirlineSearch-enter,
    .destAirlineSearch-leave-to {
        opacity: 0;
    }

    .destAirlineQuery {
        position: absolute;

        /* display: none; */

        /* z-index: 3; */
        top: -99999px;
        left: -99999px;
        box-sizing: border-box;
        width: 461px;
        min-height: 200px;
        padding: 23px 17px;
        background-color: rgba(255, 255, 255, 0.8);
        border: 1px solid #808080;
    }

    .destAirlineQuery .close {
        position: absolute;
        top: 4px;
        right: 5px;
        font-size: 20px;
        cursor: pointer;
    }

    .destAirlineQuery .close .iconfont.icon-chahao {
        font-size: 20px;
    }

    .destAirlineQuery .titsBox {
        position: relative;
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
    }

    .destAirlineQuery .titsBox > a {
        float: left;
        margin-right: 24px;
        margin-left: 5px;

        /* display: none; */
        color: #4d4d4d;
    }

    .destAirlineQuery .titsBox > a.active {
        color: #409eff;
    }

    .destAirlineQuery .classifyBox {
        position: relative;
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
    }

    .destAirlineQuery .classifyBox > a {
        display: inline-block;
        float: left;
        margin-right: 8px;
        margin-left: 5px;
        color: #4d4d4d;
    }

    .destAirlineQuery .classifyBox > a.active {
        color: #409eff;
    }

    .destAirlineQuery .dataList {
        position: relative;
        width: 100%;
        margin: 5px auto 0;
        overflow: hidden;
    }

    .destAirlineQuery .dataList > a {
        position: relative;
        box-sizing: border-box;
        display: block;
        float: left;
        width: 20%;
        padding: 6px 3px;
        overflow: hidden;
        color: #4d4d4d;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: 0.3s all;
    }

    .destAirlineQuery .dataList > a:hover {
        color: #f7931e;
    }

    .destAirlineFuzzy {
        position: absolute;

        /* display: none; */

        /* z-index: 3; */
        top: -99999px;
        left: -99999px;
        box-sizing: border-box;
        width: 357px;
        max-height: 280px;
        padding: 4px 9px;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: rgba(255, 255, 255, 0.9);
        border: 1px solid rgba(128, 128, 128, 0.784);
    }

    .destAirlineFuzzy > .fuzzy {
        position: relative;
        box-sizing: border-box;
        display: block;
        height: 32px;
        line-height: 32px;
        border-bottom: 1px dashed #808080;
    }

    .destAirlineFuzzy > .fuzzy.invalid {
        cursor: no-drop;
    }

    .destAirlineFuzzy > .fuzzy.invalid::after {
        position: absolute;
        top: 50%;
        left: 1%;
        display: block;
        width: 98%;
        height: 1px;
        content: '';
        background-color: rgba(128, 128, 128, 1);
    }

    .destAirlineFuzzy > .fuzzy:last-child {
        border-bottom: none;
    }

    .destAirlineFuzzy > .fuzzy > span {
        font-size: 12px;
        color: #4d4d4d;
    }

    .destAirlineFuzzy > .fuzzy > span > em {
        font-style: normal;
        color: #409eff;
    }

    .destAirlineFuzzy > .fuzzy .text1 {
        float: left;
        max-width: 34px;
        padding-right: 5px;
        padding-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .destAirlineFuzzy > .fuzzy .text2 {
        float: left;
        max-width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .destAirlineFuzzy > .fuzzy .text3 {
        float: right;
        width: 58px;
        padding-right: 5px;
        overflow: hidden;
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .destAirlineFuzzy > .fuzzy .now {
        float: right;
        width: 58px;
        padding-right: 10px;
        padding-left: 10px;
        overflow: hidden;
        color: #f7931e;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .destAirlineLoading {
        position: absolute;

        /* display: none; */

        /* z-index: 3; */
        top: -99999px;
        left: -99999px;
        width: 348px;
        height: 40px;
        font-size: 15px;
        line-height: 40px;
        text-align: center;
        background-color: rgba(255, 255, 255, 0.9);
        border: 1px solid rgba(128, 128, 128, 0.784);
    }

</style>
